import React, {ComponentType, Component} from 'react';
import {StyledComponent as StyledComponentType, AnyStyledComponent} from 'styled-components';
import {Theme} from '../theme/theme';

/**
 * TODO: Using `AnyStyledComponent` is hopefully temporary.
 * There were type issues in the render if I used `StyledComponent` instead.
 */
export const withComponent = <P, T extends Theme>(BaseComponent: ComponentType<P>) => <
    C extends keyof JSX.IntrinsicElements
>(
    StyledComponent: StyledComponentType<C, T>
) => {
    // complex type issue, using this as temporary workaround
    const StyledComponentAsAny = StyledComponent as AnyStyledComponent;

    return class WithComponent extends Component<P> {
        public static StyledComponent = StyledComponent;
        public static displayName = `withComponent(${StyledComponent.displayName})`;

        public render() {
            return <StyledComponentAsAny as={BaseComponent} {...this.props} />;
        }
    };
};
